import React, { useState } from 'react'
import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import { Box, Button, Grid, makeStyles, Typography } from '@material-ui/core'
import { ApiProvider } from '../../../../components/hooks/Map'
import { Map, Marker } from '@vis.gl/react-google-maps'

const useStyles = makeStyles({})

export const MapModal = ({
  open = false,
  handleOpen,
  lat = 0,
  lng = 0,
  onChangePosition = (lat, lng) => {},
}) => {
  const classes = useStyles()

  const handleClick = e => {
    const { lat, lng } = e.detail.latLng
    return onChangePosition(lat, lng)
  }

  return (
    <BaseFilterModal
      handleOpen={handleOpen}
      open={open}
      title={'Visualização da Coordenada'}
      hiddenHelpButton
    >
      <Grid
        item
        xs={12}
        style={{
          width: '380px',
          marginTop: '8px',
          padding: 0,
          overflow: 'hidden',
          borderRadius: '20px'
        }}
      >
        <ApiProvider>
          <Map
            key={`map-coordinates-${lat}`}
            mapId="ecab51a15bad560d"
            defaultCenter={{ lat: parseFloat(lat), lng: parseFloat(lng) }}
            defaultZoom={15}
            zoomControlOptions={false}
            streetViewControl={false}
            cameraControl={false}
            style={{ width: '100%', height: '400px'}}
            onClick={handleClick}
          >
            <Marker position={{ lat: parseFloat(lat), lng: parseFloat(lng) }} />
          </Map>
        </ApiProvider>
      </Grid>
    </BaseFilterModal>
  )
}
